import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function PricingSection() {
  const valueStack = [{
    text: '69 técnicas de estimulación oral',
    value: '$8.000'
  }, {
    text: '29 movimientos paso a paso',
    value: '$6.000'
  }, {
    text: 'Guía de Comunicación Íntima',
    value: '$22.000'
  }, {
    text: '15 Posiciones que Potencian el Placer',
    value: '$25.000'
  }, {
    text: 'Audio Guía de Relajación Sensual',
    value: '$20.000'
  }, {
    text: 'Checklist de Confianza Personal',
    value: '$21.000'
  }, {
    text: 'Guía de Juegos Previos Irresistibles',
    value: '$23.000'
  }, {
    text: 'Manual de Seducción con la Mirada',
    value: '$20.000'
  }, {
    text: 'Guía de Respiración y Control',
    value: '$24.000'
  }, {
    text: 'E-book: Secretos del Lenguaje Corporal',
    value: '$22.000'
  }, {
    text: 'Guía de Fantasías y Juegos de Rol',
    value: '$25.000'
  }, {
    text: 'Kit de Masajes Sensuales Paso a Paso',
    value: '$23.000'
  }, {
    text: 'Actualizaciones de por Vida',
    value: '$23.000',
    highlight: true
  }];
  return <section id="pricing" className="py-24 bg-[#0D0118] relative px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-123">
      {/* Spotlight Effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[600px] bg-[#FF2D8A]/20 blur-[150px] rounded-full pointer-events-none" data-id="element-124"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-125">
        <div className="text-center mb-12" data-id="element-126">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-4" data-id="element-127">
            Accedé a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF2D8A] to-[#9D00FF]" data-id="element-128">
              Expertas en BallCat
            </span>
          </h2>
          <p className="text-xl text-gray-300" data-id="element-129">
            Todo lo que necesitás para convertirte en una maestra del placer.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-b from-white/10 to-white/5 backdrop-blur-xl border border-[#FF2D8A]/30 rounded-[2.5rem] p-8 sm:p-12 shadow-[0_0_50px_rgba(255,45,138,0.15)] relative overflow-hidden" data-id="element-130">
          {/* Top Banner */}
          <div className="absolute top-0 left-0 w-full bg-gradient-to-r from-[#FF2D8A] to-[#9D00FF] py-2 text-center text-white font-bold text-sm tracking-widest uppercase" data-id="element-131">
            Oferta Especial Limitada
          </div>

          <div className="mt-8 mb-10" data-id="element-132">
            <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-133">
              Esto es todo lo que te llevás hoy:
            </h3>
            <ul className="space-y-4" data-id="element-134">
              {valueStack.map((item, index) => <li key={index} className="flex items-center justify-between border-b border-white/10 pb-3 last:border-0" data-id="element-135">
                  <div className="flex items-center gap-3" data-id="element-136">
                    <CheckIcon className={`w-5 h-5 ${item.highlight ? 'text-[#FFD700]' : 'text-[#22C55E]'}`} data-id="element-137" />
                    <span className={`text-lg ${item.highlight ? 'text-[#FFD700] font-bold' : 'text-gray-200'}`} data-id="element-138">
                      {item.text}
                    </span>
                  </div>
                  <span className="text-sm text-gray-400 line-through hidden sm:block" data-id="element-139">
                    Valor {item.value}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="text-center border-t border-white/20 pt-10" data-id="element-140">
            <p className="text-gray-400 mb-2" data-id="element-141">
              Valor Total:{' '}
              <span className="line-through text-red-400" data-id="element-142">$216.000</span>
            </p>
            <div className="flex flex-col items-center justify-center mb-2" data-id="element-143">
              <span className="text-sm font-bold text-[#FFD700] uppercase tracking-wider mb-1" data-id="element-144">
                Por solo
              </span>
              <span className="text-6xl sm:text-7xl font-black text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.3)]" data-id="element-145">
                $14.999{' '}
                <span className="text-2xl text-gray-400 font-bold" data-id="element-146">ARS</span>
              </span>
            </div>
            <p className="text-gray-300 font-medium mb-8" data-id="element-147">
              Pago único - Acceso inmediato y de por vida
            </p>

            <Button href="#" className="w-full sm:w-auto text-xl px-12 py-6 mb-6 shadow-[0_0_40px_rgba(255,45,138,0.6)]" data-id="element-148">
              ¡SÍ, QUIERO ACCEDER AHORA!
            </Button>

            <div className="flex items-center justify-center gap-3 text-gray-400 bg-black/20 py-3 px-6 rounded-full inline-flex mx-auto" data-id="element-149">
              <ShieldCheckIcon className="w-6 h-6 text-[#22C55E]" data-id="element-150" />
              <span className="text-sm font-medium" data-id="element-151">
                7 días de garantía - Si no te gusta, te devolvemos el 100%
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}